export default "__VITE_ASSET__jgGiLrE$__"